import Api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";

export function loadOfferFinancialServices(documentId, siteId) {
  return async (dispatch, getState) => {
    let { documentLoaded } = getState().currentOffer.financialServicesData;
    if (documentLoaded) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_STARTED, payload: { documentId, siteId } });
    try {
      let document = await dispatch(sendHttpRequest(Api.getFinancialServices(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_SUCCEEDED, payload: { document } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function computeOfferFinancialServices(documentId, siteId, header, serviceDetails) {
  return async dispatch => {
    dispatch({
      type: actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_STARTED,
      payload: { documentId, siteId, header, serviceDetails }
    });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        Api.computeOfferFinancialServices(documentId, siteId, header, serviceDetails),
        "ComputeOfferFinancialServicesCommand",
        [eventTypes.OFFER_FINANCIAL_SERVICES_COMPUTED],
        false
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_SUCCEEDED,
            payload: { documentId, siteId, header, serviceDetails, services: event.eventBody.services }
          });
        } else {
          dispatch({
            type: actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_FAILED,
            payload: { documentId, siteId, header, serviceDetails, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_FAILED,
          payload: { documentId, siteId, header, serviceDetails, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveOfferFinancialServices(documentId, siteId, document, services, useExtendedFields) {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_STARTED, payload: { documentId, siteId, document } });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        Api.updateOfferFinancialServices(documentId, siteId, document.header, services, useExtendedFields),
        "UpdateOfferFinancialServicesCommand",
        [eventTypes.OFFER_FINANCIAL_SERVICES_UPDATED]
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_SUCCEEDED,
            payload: { documentId, siteId, document }
          });
        } else {
          dispatch({
            type: actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_UPDATE_FAILED,
            payload: { documentId, siteId, document, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_UPDATE_FAILED,
          payload: { documentId, siteId, document, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function loadWheelSizes(documentId, siteId) {
  return async (dispatch, getState) => {
    let { wheelSizesLoaded } = getState().currentOffer.financialServicesData;
    if (wheelSizesLoaded) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_WHEELS_SIZES_STARTED, payload: { documentId, siteId } });
    try {
      let wheelSizes = await dispatch(sendHttpRequest(Api.loadWheelSizes(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_WHEELS_SIZES_SUCCEEDED, payload: { documentId, siteId, wheelSizes } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_WHEELS_SIZES_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadServiceLinking(documentId, siteId) {
  return async (dispatch, getState) => {
    let { serviceLinkingLoaded } = getState().currentOffer.financialServicesData;
    if (serviceLinkingLoaded) {
      return;
    }
    dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_LINKING_STARTED, payload: { documentId, siteId } });
    try {
      let serviceLinkingList = await dispatch(sendHttpRequest(Api.getFinancialServicesLinking(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_LINKING_SUCCEEDED, payload: serviceLinkingList });
    } catch (error) {
      dispatch({
        type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_LINKING_FAILED,
        payload: { documentId, siteId, error }
      });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadServiceTypes(documentId, siteId) {
  return async (dispatch, getState) => {
    let { serviceTypesListLoaded } = getState().currentOffer.financialServicesData;
    if (serviceTypesListLoaded) {
      return;
    }
    dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICE_TYPES_STARTED, payload: { documentId, siteId } });
    try {
      let serviceTypesList = await dispatch(sendHttpRequest(Api.getFinancialServiceTypes(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICE_TYPES_SUCCEEDED, payload: serviceTypesList });
    } catch (error) {
      dispatch({
        type: actionTypes.LOAD_OFFER_FINANCIAL_SERVICE_TYPES_FAILED,
        payload: { documentId, siteId, error }
      });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveAddedServices(documentId, siteId, addedServices) {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_ADDED_SERVICES_STARTED, payload: { documentId, siteId } });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        Api.addServices(documentId, siteId, addedServices),
        "UpdateOfferFinancialServicesCommand",
        [eventTypes.OFFER_FINANCIAL_SERVICES_UPDATED]
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.SAVE_ADDED_SERVICES_SUCCEEDED,
            payload: { documentId, siteId }
          });
        } else {
          dispatch({
            type: actionTypes.SAVE_ADDED_SERVICES_FAILED,
            payload: { documentId, siteId, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SAVE_ADDED_SERVICES_FAILED,
          payload: { documentId, siteId, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function deleteService(documentId, siteId, deletedServiceId) {
  return async dispatch => {
    dispatch({ type: actionTypes.DELETE_SERVICE_STARTED, payload: { documentId, siteId } });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(Api.deleteService(documentId, siteId, deletedServiceId), null, [
          eventTypes.OFFER_FINANCIAL_SERVICES_UPDATED
        ])
      );
      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function changeEditableProperty(value) {
  return dispatch => {
    dispatch({ type: actionTypes.CHANGE_EDITABLE_PROPERTY, payload: { value } });
  };
}

export function cancelFinancialServicesChanges(documentId, siteId) {
  return { type: actionTypes.CANCEL_OFFER_FINANCIAL_SERVICES_CHANGES, payload: { documentId, siteId } };
}
